import get from "lodash/get";
import React, { useEffect, useState } from "react";
import "./toprowad.m.css";
import { DfpComponent } from "../../../../components/ads/dfp-component";

export const TopRowAd = ({ config, collection, isDesktop }) => {
  const networkId = get(config, ["ads-config", "network_id"], {});
  const associatedMetadata = get(collection, ["associated-metadata"], {});
  const [adComponent, setAdComponent] = useState();
  useEffect(() => {
    setAdComponent(
      <>
          {isDesktop && associatedMetadata.desktop_component_ad_unit && (
            <DfpComponent
              id={`newsletter-ad-${collection.id}`}
              path={`/${networkId}/${associatedMetadata.desktop_component_ad_unit}`}
              adSlotConfigName="mRec_ad"
              showText={false}
              adStyleName="ad-style-300x250"
            />
          )}
          {!isDesktop && associatedMetadata.mobile_component_ad_unit && (
            <DfpComponent
              id={`newsletter-ad-mobile-${collection.id}`}
              path={`/${networkId}/${associatedMetadata.mobile_component_ad_unit}`}
              adSlotConfigName="mRec_ad"
              showText={false}
              adStyleName="ad-style-300x250"
            />
          )}
      </>
    );
  }, []);

  return (
    <div className="newsletter-container" styleName="newsletter-container">
      <div styleName="ad-wrapper-newsletter">{adComponent}</div>
    </div>
  );
};
